import T from 'prop-types'
import Container from 'components/Container'
import Button from 'components/Button'
import useSession from 'hooks/useSession'
import Block from 'components/Block'
import { removeItem } from 'lib/storage'
import Header from 'apps/booking/components/Header'

export default function BookingFailedBehalfOfPage({
  match: {
    params: { orgUnit },
  },
}) {
  const { clearSession } = useSession()

  // Flush the session storage to prevent user from going back and trying again
  removeItem('bookingState')

  return (
    <>
      <Header />

      <Container size="tight">
        <h1>Du kan ikke bestille time enda</h1>

        <p>Personen du prøver å bestille time for er ikke i målgruppen for vaksine nå.</p>

        <p>Ta kontakt med vaksinasjonskontoret dersom du mener dette er feil.</p>

        <Block top={5}>
          <Button onClick={() => clearSession(`/${orgUnit}`)} primary>
            Avslutt og logg ut
          </Button>
        </Block>
      </Container>
    </>
  )
}

BookingFailedBehalfOfPage.propTypes = {
  match: T.shape({
    params: T.shape({
      orgUnit: T.string.isRequired,
    }).isRequired,
  }).isRequired,
}
